import { render, staticRenderFns } from "./HelpCircleOutlineIcon.vue?vue&type=template&id=22ad94a5"
import script from "./HelpCircleOutlineIcon.vue?vue&type=script&lang=js"
export * from "./HelpCircleOutlineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports